/**
 * use this file to register and export all API handler that will be used in the system
 **/

import type { InjectionKey } from 'vue';
import { PortalHeaderApi } from './portal-header-api';

export const portalHeaderApiKey: InjectionKey<PortalHeaderApi> = Symbol('portalHeaderApi');
/**
 * Provides api's that also need to be available server-side to be used within pages of the application.
 * @param baseUrl Base url of the api we are calling (EJP backend)
 */
export default function useProvideApi(baseUrl: string) {
	const app = useNuxtApp();
	app.vueApp.provide(portalHeaderApiKey, new PortalHeaderApi(baseUrl));
}
